<script setup lang="ts">
import { ref, watch } from 'vue'
const props = withDefaults(defineProps<{
  title: string; summary?: string | null; alert?: boolean
  testid?: string; defaultOpen?: boolean
}>(), { summary: null, alert: false, defaultOpen: false })
const open = ref(props.defaultOpen || props.alert)
const userToggled = ref(false)
watch(() => props.alert, (a) => {
  if (a) { if (!userToggled.value) open.value = true }
  else { userToggled.value = false } // alert episode cleared -> re-arm auto-open for the next one
})
function toggle() { userToggled.value = true; open.value = !open.value }
</script>

<template>
  <div class="cc-card" :class="{ 'cc-alert': alert }" :data-testid="testid">
    <div class="cc-header" data-cc-header @click="toggle">
      <span class="cc-caret">{{ open ? '▾' : '▸' }}</span>
      <span class="cc-title">{{ title }}</span>
      <span v-if="!open" class="cc-summary" :class="{ 'cc-summary-alert': alert }">
        <slot name="summary">{{ summary }}</slot>
      </span>
    </div>
    <div v-if="open" class="cc-body"><slot /></div>
  </div>
</template>

<style scoped>
.cc-card { background: #161b22; border: 1px solid #30363d; border-radius: 8px; }
.cc-alert { border-color: #d29922; }
.cc-header { display: flex; gap: 8px; align-items: baseline; padding: 7px 12px; cursor: pointer; font-size: .8rem; color: #c9d1d9; }
.cc-caret { color: #6e7681; }
.cc-title { font-weight: 600; }
.cc-summary { color: #8b949e; font-size: .75rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; min-width: 0; flex: 1 1 auto; }
.cc-summary-alert { color: #d29922; }
.cc-body { padding: 4px 12px 10px; }
</style>
